import React, { useState } from "react";
import axios from "axios";
import { Modal, Button } from "react-bootstrap";
import Swal from "sweetalert2";

function ModalValoracion({ idReserva, idServicio, idComprador, idVendedor, nombreUsuario }) {
  const [show, setShow] = useState(false);
  const [cargando, setCargando] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  
  
  const formInicial = {
    idReserva: idReserva || "",
    idServicio: idServicio || "",
    idVendedor: idVendedor || "",
    idComprador: idComprador || "",
    nombreUsuario: nombreUsuario || "",
    calificacion: 5,
    comentario: "",
  };
  console.log("form inicial: ", formInicial);
  const [form, setForm] = useState(formInicial);

  function cambiarCampo(campo, valor) {
    setForm((prev) => ({ ...prev, [campo]: valor }));
  }

  async function enviarValoracion() {
    try {
      const idReservaFinal     = (form.idReserva || "").trim();
      const idServicioFinal    = (form.idServicio || "").trim();
      const idVendedorFinal    = (form.idVendedor || "").trim();
      const idCompradorFinal   = (form.idComprador || "").trim();
      const nombreUsuarioFinal = (form.nombreUsuario || "").trim();
      const calificacion       = Number(form.calificacion || 0);
      const comentario         = (form.comentario || "").trim();

      if (!idReservaFinal || !idServicioFinal || !idVendedorFinal || !idCompradorFinal) {
        return Swal.fire({
          icon: "error",
          title: "Faltan datos",
          text: "No encontramos todos los datos necesarios para guardar la reseña.",
          customClass: { popup: "mi-modal", confirmButton: "mi-boton-confirmar" },
        });
      }

      if (!(calificacion >= 1 && calificacion <= 5)) {
        return Swal.fire({
          icon: "error",
          title: "Calificación inválida",
          text: "La calificación debe estar entre 1 y 5.",
          customClass: { popup: "mi-modal", confirmButton: "mi-boton-confirmar" },
        });
      }

      setCargando(true);

      await axios.post(
        "/crear-valoracion",
        {
          params: {
            idReserva: idReservaFinal,
            idServicio: idServicioFinal,
            idVendedor: idVendedorFinal,
            idComprador: idCompradorFinal,
            calificacion,
            comentario,
            nombreUsuario: nombreUsuarioFinal,
          },
        },
        { withCredentials: true }
      );

      Swal.fire({
        icon: "success",
        title: "Reseña enviada",
        text: "Gracias por compartir tu experiencia.",
        customClass: { popup: "mi-modal", confirmButton: "mi-boton-confirmar" },
      });

      setForm({ ...formInicial, comentario: "", calificacion: 5 });
      handleClose();
    } catch (err) {
      console.log("Error enviando valoración:", err);

      return Swal.fire({
        icon: "error",
        title: "No se pudo enviar",
        text: err?.response?.data?.mensaje || "No pudimos guardar la reseña. Intenta nuevamente.",
        customClass: { popup: "mi-modal", confirmButton: "mi-boton-confirmar" },
      });
    } finally {
      setCargando(false);
    }
  }

  return (
    <div>
      <Button
        className="w-100 mt-3 rounded-pill fw-semibold border-0 shadow-sm d-flex align-items-center justify-content-center gap-2"
        onClick={handleShow}
        style={{
          background: "linear-gradient(135deg, var(--azul-logo-claro), var(--azul-ui))",
          color: "var(--blanco)",
          padding: "12px 18px",
          letterSpacing: "0.2px",
        }}
      >
        <span
          className="d-inline-flex align-items-center justify-content-center rounded-circle"
          style={{
            width: 28,
            height: 28,
            background: "rgba(var(--blanco-rgb),0.18)",
          }}
        >
          <i className="bi bi-star-fill"></i>
        </span>
        Deja tu reseña
      </Button>

      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="fw-bold text-dark">
            Deja tu reseña
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="p-2 p-md-3">
            <div className="mb-3">
              <p className="text-muted mb-0">
                Califica cómo fue tu experiencia. Tu reseña ayuda a otros usuarios a tomar mejores decisiones.
              </p>
            </div>

            <div className="row g-3">
              <div className="col-12">
                <label className="form-label fw-semibold">Calificación</label>
                <select
                  className="form-select"
                  value={form.calificacion}
                  onChange={(e) => cambiarCampo("calificacion", Number(e.target.value))}
                  disabled={cargando}
                >
                  <option value={5}>5 ⭐ Excelente</option>
                  <option value={4}>4 ⭐ Muy bueno</option>
                  <option value={3}>3 ⭐ Bueno</option>
                  <option value={2}>2 ⭐ Regular</option>
                  <option value={1}>1 ⭐ Malo</option>
                </select>
              </div>

              <div className="col-12">
                <label className="form-label fw-semibold">Comentario</label>
                <textarea
                  className="form-control"
                  style={{ height: 130 }}
                  value={form.comentario}
                  onChange={(e) => cambiarCampo("comentario", e.target.value)}
                  placeholder="Cuéntanos cómo fue el servicio..."
                  maxLength={800}
                  disabled={cargando}
                />

                <div className="text-end small text-muted mt-1">
                  {(form.comentario || "").length}/800
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer className="border-0 pt-0">
          <Button variant="outline-secondary" onClick={handleClose} disabled={cargando}>
            Cancelar
          </Button>

          <Button
            variant="primary"
            disabled={cargando}
            onClick={() => {
              Swal.fire({
                icon: "question",
                title: "¿Enviar reseña?",
                text: "Tu calificación quedará guardada en el servicio.",
                showCancelButton: true,
                confirmButtonText: "Enviar",
                cancelButtonText: "Cancelar",
                customClass: {
                  popup: "mi-modal",
                  confirmButton: "mi-boton-confirmar",
                  cancelButton: "mi-boton-cancelar",
                },
              }).then((r) => {
                if (r.isConfirmed) enviarValoracion();
              });
            }}
          >
            {cargando ? "Enviando..." : "Enviar reseña"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default ModalValoracion;